<template>
  <aside :class="['main-sidebar', 'col-12', 'col-md-3', 'col-lg-2', 'px-0', sidebarVisible ? 'open' : '']">
      <div class="main-navbar logo">
        <nav class="navbar align-items-stretch navbar-light bg-primary flex-md-nowrap border-bottom p-0">
          <a class="navbar-brand w-100 h-100 mr-0" href="#" style="line-height: 25px;">
            <div class="d-table ml-4 my-auto">
              <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 25px;" src="@/assets/images/logo-tg-lp.png" alt="Total grass - Vestiario">
              <span v-if="!hideLogoText" class="d-none d-md-inline text-white">Vestiário</span>
            </div>
          </a>
          <a class="toggle-sidebar d-sm-inline d-md-none d-lg-none text-white" @click="handleToggleSidebar()">
            <i class="material-icons">&#xE5C4;</i>
          </a>
        </nav>
      </div>

      <div class="nav-wrapper">
          <d-nav class="flex-column">
            <li
              v-for="(item, navItemIdx) in menu"
              :key="item.name"
              class="nav-item dropdown"
            >
              <d-link
                :to="item.to"
                @click="handleToggleSidebar()"
                v-d-toggle="`sync-${navItemIdx}`"
                :class="['nav-link', item.items && item.items.length ? 'dropdown-toggle' : '']"
              >
                <div class="item-icon-wrapper" v-if="item.htmlBefore" v-html="item.htmlBefore" />
                <span v-if="item.title">{{ item.title }}</span>
                <div class="item-icon-wrapper" v-if="item.htmlAfter" v-html="item.htmlAfter" />
              </d-link>
              <d-collapse
                :id="`sync-${navItemIdx}`"
                accordion="sidebar-items-accordion"
                v-if="item.items && item.items.length"
                class="dropdown-menu dropdown-menu-small"
              >
                <d-link
                  class="dropdown-item nav-link"
                  :to="subItem.to"
                  :key="subItem.title"
                  :href="subItem.href"
                  v-for="subItem in item.items"
                  @click="handleToggleSidebar()"
                  v-if="checkAccess(subItem)"
                >
                  {{ subItem.title }}
                </d-link>
              </d-collapse>
            </li>
          </d-nav>
      </div>
  </aside>
</template>

<script>
import Events from '_utils/events';
import SessionService from '_services/common/sessionService';

export default {
  name: 'main-sidebar',
  props: {
    /**
      * Whether to hide the logo text, or not.
      */
    hideLogoText: {
      type: Boolean,
      default: false,
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    menu() {
      return this.items.filter(item => (this.modules.includes(item.name) || item.name === 'dashboard') && this.checkAccess(item));
    },
    isCustomer() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 3) {
        return true;
      }
      return false;
    },
    isAdmin() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 1) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      sidebarVisible: false,
      modules: [],
    };
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    checkAccess(item) {
      if (this.isCustomer && item.isCustomer === false) {
        return false;
      }
      if (!this.isAdmin && 'isAdmin' in item) {
        return this.isAdmin;
      }
      return true;
    },
  },
  created() {
    const { modules } = SessionService.getLocalData('_user');
    this.modules = modules.map(module => module.slug);
    this.$eventHub.$on('toggle-sidebar', this.handleToggleSidebar);
    Events.$on('sidebarVisible', sidebarVisible => { this.sidebarVisible = sidebarVisible; });
  },
  beforeDestroy() {
    this.$eventHub.$off('toggle-sidebar');
  },
};
</script>

<style lang="scss">
  .main-sidebar {
    .item-icon-wrapper {
      display: inline-block;
    }
    .dropdown-menu {
      display: block;
    }
  }
</style>
